import { get, patch } from '@nbx/frontend-helpers/fetch-api';
import { context } from '@nbx/frontend-helpers/auth';

let baseUrl = 'users';

const NBXUsers = {
  init: config => ({ baseUrl } = config),

  getPreferences: async () => {
    const user = await context.user();
    return get(`${baseUrl}/users/${user.id}/preferences`, user);
  },

  getMarketAlerts: async market => {
    const user = await context.user();
    return get(`${baseUrl}/users/${user.id}/preferences/market-alerts/${market}`, user);
  },

  patchMarketAlerts: async (market, enabled) => {
    const user = await context.user();
    const payload = { json: { priceVolatility: { enabled } } };
    return patch(`${baseUrl}/users/${user.id}/preferences/market-alerts/${market}`, payload, user);
  }
};

export default NBXUsers;
